export default __webpack_public_path__ + "static/media/cvod-13.a34145a9.svg";